import { render, staticRenderFns } from "./leaving.vue?vue&type=template&id=c4c57ce2&scoped=true&"
import script from "./leaving.vue?vue&type=script&lang=js&"
export * from "./leaving.vue?vue&type=script&lang=js&"
import style0 from "./leaving.vue?vue&type=style&index=0&id=c4c57ce2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c57ce2",
  null
  
)

export default component.exports